package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_01_25_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had just entered the bottom floor of the Thardos Family Ruins. The heroes initially snuck in with some deception, but the guards had been quickly alerted, and the heroes fell back to Plan B (violence).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes hear a deep bellowing voice, “Crush this vermin and bring me what I seek.” Three more enemies appear south of Annette, Goram, and Bigglesworth. Goram moves to the door to prevent new enemies from entering. When Annette fireballs the enemies in the southern room, several bricks and a cloud of dust falls from the walls and ceiling but the roof does not collapse. An enemy named Frank, outnumbered by Falorn, Caper, Dirk, and Tuesday, tries to flee but gets stuck in the window. After the heroes kill all enemies, four more enemies approach from the South West room; the heroes kill them. During the fighting, Tuesday used his magic to “animate” his circles (coins), creating a lethal swarm of flying metal that tore through the flesh of all “bad men” in its path. The heroes remark on the magic’s effectiveness and Tuesday’s unconventional approach to combat. Caper grabs some bread and cheese from the kitchen. Falorn gives her the stink eye (apparently Caper is not satisfied with magical oatmeal?).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday flies out the window to scout the upper level before the the heroes climb the stairs. He looks through a second floor window on the west side. He sees")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Blue Crystals (2-8 feet tall)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Rubble (the second floor roof had collapsed, probably long ago)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Samuel Thardos sitting on a throne, drinking wine")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A shiny chest")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Statues")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday reports his findings.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes plan their assault. Caper and Tuesday will fly to the second floor level and wait. Goram will lead the others up the stairs. When Goram reaches the top of the stairs, Caper and Tuesday will enter through the second floor windows. The heroes execute their coordinated entrance; Falorn has the first opportunity to attack and misses heroically. Samuel Thardos uses magic to spawn three Chimera on the floating purple crystalline structures. Samuel Thardos turns himself into Do’Shara, the Blue Dragon. The heroes see that the crystalline structure under the Chimera have a tether to the Blue Dragon.")
    }
}
